export const iconFontAwesomeNumbers6 = (
	<i className="fa-solid fa-6"></i>
);
